import { getLens } from '@opengov/api-deprecated';
import { ISavedView } from '@opengov/reporting-types/src/reportSavedView';

import { reportConfigurationEffects } from '../../../../../module/effects';
import { savedViewEffects } from '../../../savedViews';

export const fetchDataForClipboard = async (reportId: string, lensId: string, defaultReportConfigurationId: string) => {
  let lens = null;
  const defaultReportConfiguration = await reportConfigurationEffects.getReportConfiguration({
    reportConfigurationId: defaultReportConfigurationId
  });
  const savedViews = await savedViewEffects.loadSavedViewsForReportId({ reportId });
  const savedViewsWithReportConfigurations = await Promise.all(
    (savedViews as ISavedView[]).map(async (savedView) => {
      const reportConfiguration = await reportConfigurationEffects.getReportConfiguration({
        reportConfigurationId: savedView.reportConfiguration
      });

      return {
        ...savedView,
        reportConfiguration
      };
    })
  );

  if (lensId) {
    lens = await getLens(lensId);
  }

  return {
    defaultReportConfiguration,
    savedViewsWithReportConfigurations,
    lens
  };
};
